import axiosHttp from "./interceptor.service";

const postHrAdminWork = (data) => {
    return axiosHttp.post("/feedback/createHrAdminWork", data);
};

const getHrAdminWork = ({ sort, page, limit, search, departmentId, inchargeId, completedDate, isTask, urgencyStatus } = {}) => {
    return axiosHttp.get("/feedback/getHrAdminWork", {
        params: { sort, page, limit, search, departmentId, inchargeId, completedDate, isTask, urgencyStatus },
    });
};

const updateHrAdminWork = (id, data) => {
    return axiosHttp.put(`/feedback/updateHrAdminWork/${id}`, data);
};

const deleteHrAdminWork = (id) => {
    return axiosHttp.delete(`/feedback/deleteHrAdminWork/${id}`);
};

const getHrAdminWorkHistory = (workId) => {
    return axiosHttp.get("/feedback/getHrAdminWorkHistory", {
        params: { workId }
    });
};

export { postHrAdminWork, getHrAdminWork, updateHrAdminWork, deleteHrAdminWork, getHrAdminWorkHistory };
